import React, { useState, useEffect } from "react";
// import EnhancedTable from "components/EnhancedTable";
import NewUserForm from "./NewUserForm";
import EditUserForm from "./EditUserForm";
import axios from "axios";
import { baseUrl } from "../../helpers/Constants";
import { makeStyles } from "@material-ui/core/styles";
import CheckedTable from "./CheckedTable";
import Spinner from "components/Spinner";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { userTableHeaders, createUserRecord } from "../../helpers/schemas/User";
import UserProfile from "glite-views/UserProfile";
import Supplier from "glite-views/Supplier";
const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },
}));

export default function UserBioData() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("");
  const [userError, setUserError] = useState(undefined);
  const [tableLoading, setTableLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [profileView, setProfileView] = useState(false);
  const [supplierView, setSupplierView] = useState(false);
  const [languageKv, setLanguageKv] = useState([]);
  
  useEffect(() => {
    setTableLoading(true);
    axios
      .get(`${baseUrl}users`)
      .then((response) => {
        //console.log("User JSON", JSON.stringify(response));
        let result = response.data.map((rec) => createUserRecord(rec));
        setData(result);
        setTableLoading(false);
      })
      .catch((error) => {
        console.log("xxxx err", JSON.stringify(error.response));
        setTableLoading(false);
      });

      axios
      .get(`${baseUrl}languages`)
      .then((response) => {
        let result = response.data.map((rec) => {
          return { key: rec.id, value: rec.name, label: rec.name };
        });
        result.unshift({ key: 1, value: "None", label: "None" });
        setLanguageKv(result);
      })
      .catch((error) => {
        console.log("xxxx err", JSON.stringify(error.response));
    });

  }, []);
  
  function handleBackToCreate() {
    setFormData({});
  }
  function handleBackToEdit() {
    setProfileView(false);
    setSupplierView(false);
  }
  function handleViewProfile() {
    setProfileView(true);
  }
  function loadSupplierView() {
    setSupplierView(true);
  }
  function loadEditData(tableData) {
    let userSelected = {};
    Object.keys(tableData).forEach(
      (k) => (userSelected[k] = tableData[k].value)
    );
    //console.log(userSelected);
    return userSelected;
  }
  function saveEdit(editedUser) {
    setUserError(undefined);
    setStatus("");
    setLoading(true);
    axios
      .put(baseUrl + "users/" + editedUser.id, editedUser)
      .then((newRecord) => {
        let transformed = createUserRecord(newRecord.data);
        let newData = data.map((oldRecord) => {
          let updated =
            oldRecord.id.value === editedUser.id ? transformed : oldRecord;
          return updated;
        });
        setFormData(transformed);
        setData(newData);
        setLoading(false);
        setStatus("SUCCESS");
      })
      .catch((error) => {
        console.log("xxx error", JSON.stringify(error));
        if (error.response.status === 400) {
          setUserError(error.response.data.message);
        }
        setLoading(false);
        setStatus("FAILED");
      });
  }
  function create(newUser) {
    
    //console.log("New User", JSON.stringify(newUser));

    setUserError(undefined);
    setStatus("");
    setLoading(true);
    newUser.userName = newUser.email;
    axios
      .post(baseUrl + "auth/signup", newUser)
      .then(() => {
        setLoading(false);
        setStatus("SUCCESS");
      })
      .catch((error) => {
        console.log("xxx error", JSON.stringify(error));
        // if (error.response.status === 400) {
        //   setUserError(error.response.data.message);
        // }
        setLoading(false);
        setStatus("FAILED");
      });
  }
  const classes = useStyles();
  return profileView || supplierView ? (
    <div>
      <Tooltip title="Back to edit">
        <IconButton onClick={handleBackToEdit}>
          <ArrowBackIcon />
        </IconButton>
      </Tooltip>
      {profileView && <UserProfile userId={formData.id.value} />}
      {supplierView && <Supplier userId={formData.id.value} />}
    </div>
  ) : (
    <div>
      <div className={classes.root}>
        {formData.id ? (
          <div>
            <Tooltip title="Back to create">
              <IconButton onClick={handleBackToCreate}>
                <ArrowBackIcon />
              </IconButton>
            </Tooltip>
            <EditUserForm
              onEdit={saveEdit}
              loading={loading}
              formData={loadEditData(formData)}
              status={status}
              onViewProfile={handleViewProfile}
              onViewSupplier={loadSupplierView}
              languageKv={languageKv}
            />
          </div>
        ) : (
          <NewUserForm
            onCreate={create}
            loading={loading}
            status={status}
            userError={userError}
            languageKv={languageKv}
          />
        )}
      </div>
      {tableLoading && <Spinner />}
      <CheckedTable
        title="Users"
        headers={userTableHeaders}
        data={data}
        setUserSelected={setFormData}
        selected={formData}
      />
    </div>
  );
}
